import React, { useState, useEffect, Fragment } from "react";
import ReactPlayer from "react-player";
import moment from "moment";
import {
  VIDEO_UPLOAD,
  IMAGE_UPLOAD,
  GIF_UPLOAD,
  YOUTUBE_URL,
} from "../../Constants/types";
import { getYoutubeId } from "../../Utils/utils";
import { getDay, getTimestring } from "../../functions/index";
const live_png = require("../../assets/media/events/live.png");
const wave_png = require("../../assets/media/events/wave.png");

const EventCard = ({ item, hex, white, onEditEvent }) => {
  const { type, time, end_time, start_time } = item;
  const [startTime, setStartTime] = useState(item.time);
  const [endTime, setEndTime] = useState(item.time);

  useEffect(() => {
    const { hh, mm, of, utc } = start_time || time;
    let hours = Number(hh);
    let minutes = Number(mm);
    if (of === "pm" && hours < 12) hours = hours + 12;
    if (of === "am" && hours === 12) hours = hours - 12;
    let m = moment();
    m.utcOffset(utc * 60);
    m.hours(hours);
    m.minutes(minutes);
    const date = m.toDate();
    setStartTime(date);
    if (end_time) {
      hours = Number(end_time.hh);
      minutes = Number(end_time.mm);
      if (end_time.of === "pm" && hours < 12) hours = hours + 12;
      if (end_time.of === "am" && hours === 12) hours = hours - 12;
      m = moment();
      m.utcOffset(end_time.utc * 60);
      m.hours(hours);
      m.minutes(minutes);
      setEndTime(m);
    }
  }, [item]);

  const onEdit = () => {};

  return (
    <div className="event-card">
      <p className="event-item-title">{item.title}</p>
      <p>{item.type}</p>
      {item.media_type === VIDEO_UPLOAD && (
        <ReactPlayer
          url={item.media_url}
          width="100%"
          height="100%"
          controls={true}
        />
      )}
      {(item.media_type === GIF_UPLOAD || item.media_type === IMAGE_UPLOAD) && (
        <div
          style={{ backgroundImage: `url(${item.media_url})` }}
          className="background"
        />
      )}
      {item.media_type === YOUTUBE_URL && (
        <iframe
          title="video"
          width="100%"
          height="100%"
          src={`//www.youtube.com/embed/${getYoutubeId(
            item.media_url
          )}?modestbranding=1&showinfo=0`}
          frameBorder="0"
          allowFullScreen
        ></iframe>
      )}
      <div className="card-content">
        {type !== "streaming" && (
          <div>
            <i className="fa fa-map-marker-alt" />
            <p className="event-item-text">{item.address.formatted_address}</p>
          </div>
        )}
        {type === "streaming" && (
          <div className="row-div">
            <img src={wave_png} width="30" />
            <p>Live stream event</p>
            <img src={live_png} width="40" />
          </div>
        )}
        <p className="event-item-Token" style={{ fontWeight: "bold" }}>
          {item.isrecurring
            ? `Every ${getDay(item.day)}`
            : moment(item.time).toDate().toLocaleDateString("en-US", {
                weekday: "long",
                month: "short",
                day: "numeric",
              })}
        </p>
        <div style={{ justifyContent: "space-around" }}>
          <p className="event-item-Token">
            Start time{" "}
            {moment(startTime).toDate().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })}
          </p>
          {endTime && (
            <p className="event-item-Token">
              End time{" "}
              {moment(endTime).toDate().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })}
            </p>
          )}
        </div>
        <p className="event-item-Token">Shopping Tokens: {item.token}</p>
        <p className="event-item-Token">
          {item.redemptionType === "ticket" ? "Ticket" : "RSVP"}
        </p>
        {item.redemptionType === "ticket" && (
          <Fragment>
            <p className="event-item-Token">
              Purchase Type: {item.purchaseType}
            </p>
            <p className="event-item-Token">Price: {item.price}</p>
          </Fragment>
        )}
        <div className="event-actions">
          <button
            onClick={onEditEvent}
            className="btn btn-brand-hex"
            style={{
              backgroundColor: hex,
              color: white ? "white" : "black",
              "--hover-text-color": "black",
              "--hover-color": "white",
              width: "100%",
            }}
            data-toggle="modal"
            data-target="#edit_event_modal"
          >
            Edit
          </button>
        </div>
      </div>
    </div>
  );
};
export default EventCard;



// WEBPACK FOOTER //
// ./src/screens/Event/EventCard.js